module.exports = __webpack_public_path__ + "static/media/5.3_preview.615d5f49.png";